<template>
  <div class="row row--cols--3 align-items-center m-0 p-5"
       :class="{'OutOfTime': isOutOfTime}" @click="seeSiteDetail">
    <div class="col--1 p-0 mb-auto">
      <smtt-icon v-if="site.siteStatus === SurveyStatus.PENDING || site.siteStatus === SurveyStatus.ALL_RECURRENT"
                 :icon="!site.outOfTime ? 'states-pending' : 'states-close'" :color="!site.outOfTime ? 'gray': 'red'" />
      <smtt-icon v-if="site.siteStatus === SurveyStatus.IN_PROGRESS" icon="states-progress" color="orange" />
      <smtt-icon v-if="site.siteStatus === SurveyStatus.RETURNED" icon="states-progress" color="#fd7e14" />
      <smtt-icon v-if="site.siteStatus === SurveyStatus.IN_REVISION" icon="states-progress" color="#007bff" />
      <smtt-icon v-if="site.siteStatus === SurveyStatus.COMPLETED" icon="states-complete" color="green" />
    </div>
    <div class="col--9 p-0">
      <div class="row m-0">
        <b class="place" :class="{'siteNameOutOfTime': isOutOfTime}">{{ site.site }}</b>
      </div>
      <div class="row m-0 gray text-break-all font-weight-bold">
        {{ `${$t('siteButtonDetails.roomCount.code.label')}: ${site.siteCode}` }}
      </div>
<!--      <status-label v-if="siteLocationNotFound" variation="danger">-->
<!--        {{ $t('siteButtonDetails.directionsNotFound') }}-->
<!--      </status-label>-->
      <hr>
      <div class="row m-0 gray">
        {{ (site.roomCount) + " " + (site.roomCount > 1 ? $t('siteButtonDetails.roomsCount2.plural') : $t('siteButtonDetails.roomsCount2.singular')) }}
      </div>
    </div>
    <div class="col--2 p-0 text-right">
      <smtt-icon icon="chevron-right" />
    </div>
  </div>
</template>

<script>
import StatusLabel from "@/components/StatusLabel.vue";
import { SurveyStatus } from "@/utils/surveyStatus";

export default {
  'name': 'SiteButtonDetails',
  'components': { StatusLabel },
  'props': {
    'site': {}
  },
  'methods': {
    seeSiteDetail() {
      this.$router.push({ 'name': 'SiteDetailsScreen', 'params': { 'assignmentId': this.site.assignmentId } })
    }
  },
  'computed': {
    SurveyStatus() {
      return SurveyStatus
    },
    'siteLocationNotFound': function () {
      return this.$store.state.siteLocations.find((siteLoc) => {
        return siteLoc.siteId === this.site.siteId
      })?.notFound
    },
    isOutOfTime() {
      return this.site.outOfTime && this.site.siteStatus !== 2
    }
  }
}
</script>

<style scoped>
  .place {
    font-size: 16px;
  }

  .text-break-all {
    word-wrap: break-word;
    word-break: break-all;
  }

  .gray {
    color: #4f4f4f
  }

  .siteNameOutOfTime {
    color: red;
  }

  .OutOfTime {
    background-color: whitesmoke;
  }
</style>
